import { render, staticRenderFns } from "./AcademyActivity.vue?vue&type=template&id=5b923a36&scoped=true"
import script from "./AcademyActivity.vue?vue&type=script&lang=js"
export * from "./AcademyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b923a36",
  null
  
)

export default component.exports